import { render, staticRenderFns } from "./VrstaSkupaForma.vue?vue&type=template&id=075e1de4&scoped=true&"
import script from "./VrstaSkupaForma.vue?vue&type=script&lang=js&"
export * from "./VrstaSkupaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e1de4",
  null
  
)

export default component.exports